import React from 'react'

// Client-facing "Your First 30 Days" vertical timeline: numbered nodes with
// label/title/tasks per phase (final phase gets the gold node), plus a
// "no gap in service" banner with a response-guarantee stat.
const StartupPlan = ({ data }) => {
  const phases = data?.phases || []
  const banner = data?.bottomBanner

  return (
    <div className="proposal-section">
      <div className="proposal-section__headline">{data?.headline || 'Your First 30 Days'}</div>
      <div className="proposal-section__accent-line" />
      {data?.lede && <div className="proposal-startup__lede">{data.lede}</div>}

      <div className="proposal-startup__timeline">
        {phases.map((phase, idx) => {
          const isFinal = idx === phases.length - 1 && phases.length > 1
          return (
            <div className="proposal-startup__step" key={idx}>
              <div className="proposal-startup__step-rail">
                <div className={'proposal-startup__step-node' + (isFinal ? ' is-final' : '')}>{idx + 1}</div>
                {!isFinal && <div className="proposal-startup__step-line" />}
              </div>
              <div className="proposal-startup__step-body">
                {phase.label && (
                  <div className={'proposal-startup__step-label' + (isFinal ? ' is-final' : '')}>{phase.label}</div>
                )}
                {phase.title && <div className="proposal-startup__step-title">{phase.title}</div>}
                {phase.tasks && phase.tasks.length > 0 && (
                  <div className="proposal-startup__step-tasks">
                    {phase.tasks.map((task, tIdx) => (
                      <div className="proposal-startup__step-task" key={tIdx}>{task}</div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {banner?.enabled && (
        <div className="proposal-startup__banner">
          <div className="proposal-startup__banner-main">
            {banner.headline && <div className="proposal-startup__banner-headline">{banner.headline}</div>}
            {banner.text && <div className="proposal-startup__banner-text">{banner.text}</div>}
          </div>
          {banner.stats && banner.stats.length > 0 && (
            <div className="proposal-startup__banner-stats">
              {banner.stats.map((stat, i) => (
                <div className="proposal-startup__banner-stat" key={i}>
                  <div className="proposal-startup__banner-stat-value">{stat.value}</div>
                  <div className="proposal-startup__banner-stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default StartupPlan
